module.exports = __webpack_public_path__ + "img/Pelegri.99a9cf6d.jpg";